import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal, setShowModalConfig } from "../uiSlice";
import { adminRolSegmento, createRol, editRol, getPantallasInicio, getRoles, getSegmentosAsignados } from "../../Services/rol_service";
import { getSegmentos } from "../../Services/segmento_service";
import { setSegmentos } from "../Segmento/segmentoSlice";

const initialState = {
    roles: [],
    rol: {
        nombre: '',
        descripcion: '',
        minCapacita: 0,
        estado: 1,
        idPantallaInicio: -1,
    },
    pantallasInicio: [],
    segmentosAsignados: [],
}

export const rolSlice = createSlice({
    name: 'rol',
    initialState,
    reducers: {
        setRoles: (state, action) => {
            state.roles = action.payload;
        },
        setRol: (state, action) => {
            state.rol = !action.payload ? initialState.rol : action.payload;
        },
        setPantallasInicio: (state, action) => {
            state.pantallasInicio = !action.payload ? initialState.pantallasInicio : action.payload;
        },
        setSegmentosAsignados: (state, action) => {
            state.segmentosAsignados = action.payload;
        }
    }
});

export const fetchRoles = createAsyncThunk(
    'roles/fetchRoles',
    async (_, { dispatch }) => {
        const rolesRes = await getRoles();
        dispatch(setRoles(rolesRes));
    }
);

export const addRol = createAsyncThunk(
    'rol/create',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const rolRes = await createRol(data);
        if (rolRes.result === 1)
            await adminRolSegmento({idRol: rolRes.data, segmentos: data.segmentos});
        dispatch(setResponse(rolRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchRoles());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const EditRol = createAsyncThunk(
    'rol/update',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        console.log(data);
        const rolRes = await editRol(data);
        if (rolRes.result === 1)
            await adminRolSegmento({idRol: rolRes.data, segmentos: data.segmentos});
        dispatch(setResponse(rolRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setShowModalConfig(false));
        dispatch(setToast(true));
        dispatch(fetchRoles());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const fetchPantallaInicio = createAsyncThunk(
    'roles/fetchPantallaInicio',
    async (_, { dispatch }) => {
        const pantallasRes = await getPantallasInicio();
        dispatch(setPantallasInicio(pantallasRes));
    }
);

export const fetchSegmentosAsignados = createAsyncThunk(
    'etiqueta/fetchSegmentosAsignados',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const segmentoRes = await getSegmentos();
        const asignadosRes = await getSegmentosAsignados(data);
        dispatch(setSegmentos(segmentoRes));
        dispatch(setSegmentosAsignados(asignadosRes ?? []));
        dispatch(setLoading(false));
    }
);

export const { setRoles, setRol, setPantallasInicio, setSegmentosAsignados } = rolSlice.actions;
export default rolSlice.reducer;